/* eslint-disable no-undef */
import React, { useContext, useState } from 'react';
import useNonInitialRenderHook from 'src/common/hooks/useNonInitialRenderHook';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
    OrdersListViewContainer,
    SetContainer,
} from './OrdersListView.styled.jsx';
import {
    BoldTruncatedItem,
    CaseRefText,
    SurgeryDateText,
    HeaderData,
    DemiText,
    BodyContainer,
    SmallHeaderText,
    StatusText,
    StatusFilterDiv,
    StatusFilterText,
    UNiDContainer,
    AccountNameNumberText,
    RegularTruncateText,
    ProcedureTruncateText,
    SplitButtonContainer,
    HeaderLeftBordered,
    HeaderDiv,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import {
    setFilters,
    getListData,
    setActionItemsOnly,
    setCalendarView,
    setListViewPageNum,
    setActiveNavLink,
} from 'src/pages/home/redux/actions';
import { getConfigurations, resetNotes } from 'src/common/redux/actions';
import {
    getEndDateForStartDate,
    getDisplayDate,
    getEndOfTimeDate,
    getNumberOfDaysBetweenTwoDates,
} from 'src/utils/dateUtils';
import {
    checkTemplateReviewUserRoleChanges,
    convertDateToISOString,
    fromOrderTypeToLabel,
    getDefaultCTAId,
    getOrderLockedAction,
    isUsageSubmissionProcessing,
    getReportUsageResourceType,
    getRoutePathWithParams,
    getUserDetails,
    fromOrderTypeToModuleName,
    logErrorToConsole
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { getCTAWCMSLink } from 'src/constants/wcmsRedirectionLinks';
import {
    CTA_IDS,
    ORDER_TYPES,
    ENABLED,
    OrderStatuses,
    SURGERY_TEMPLATE_MANDATORY_FIELDS,
    ORDERS,
    VISIBLE,
    EQUITY,
    REPORT_PROCEDURE_DATA,
    NO_USAGE_REPORT,
    isCopyCtaId,
    isTrueCopyCtaId,
} from 'src/constants/appConstants';
import UnidHubOrderDeletePopup from 'src/pages/orders/components/unidHubOrderDeletePopup/UnidHubOrderDeletePopup';
import {
    setItemListView,
    setSendReportModalState,
    getCheckOrderActionEligibility,
} from 'src/pages/orders/redux/actions';
import {
    setOrderSummaryModalState,
    closeOrderSummaryModalState,
    setOrderStatus,
    getOrderSummaryData,
    showDeleteOrderAction,
    setOrderSummaryTabAction,
    showHideRequestInvoice,
} from 'src/pages/orders/redux/actions';
import OrderDetails from 'src/pages/orders/components/orderDetails/OrderDetails';
import {
    storeSurgeryDetails,
    cancelUsageOrderRequest,
    setShowNoUsageToReportOrCancelPopup,
    resetProgressBarStatus,
    resetReportUsageStates,
    resetDiscrepancyUsageDetails,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import CreateTemplate from 'src/common/refactoredComponents/createTemplate';
import UnidItem from 'src/common/components/unidItem/UnidItem';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { OrderSummaryTabs } from 'src/constants/orderListConstants.js';
import RequestInvoice from 'src/pages/orders/components/reportsAndInvoice/requestInvoice/RequestInvoice';
import {
    checkIfOrderLockedFunc,
    getOrderStatusDetailsFunc,
    unlockOrderFunc,
} from 'src/pages/reportUsage/redux/saga/dataServices.jsx';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup/index.jsx';
import {
    LabelFont,
    OrderListDataContainer,
} from 'src/styles/CommonStyles.styled';
import { fetchUsageDetailsRequest } from 'src/pages/reportUsage/redux/action/actionCreators.jsx';
import {
    getSurgeryDetails,
    resetBomData,
    resetCreateOrUpdateSurgery,
    resetShipToAddress,
    resetSurgeryDetails,
    resetSurgeryDetailsReducer,
    reSetProgressBarStatus as resetProgressBarStatusSurgery,
} from 'src/pages/scheduleSurgery/redux/actions/index.js';
import { resetEquityDetails } from 'src/pages/equity/redux/actions';
import { resetConsignmentAddDetails } from 'src/pages/consignmentAdd/redux/actions';
import { RESET_CANCEL_USAGE_STATES } from 'src/pages/reportUsage/redux/action/types.jsx';
import { min } from 'moment';
import { RegularText } from '../order/Order.styled.js';
import { setPediatricCheck } from 'src/common/redux/actions/index.js';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import TorqueQRCode from 'src/common/refactoredComponents/torqueQRCode';
import {FlexColumnContainer,Title} from 'src/pages/home/component/orders/ordersListView/OrdersListView.styled';
import { setQrGenerated } from 'src/common/redux/actions';
import {PARKED_LABEL} from 'src/styles/fonts/MCFontConstants';
import { ReportUsageContext } from 'src/pages/reportUsage';
import { initialButtonState } from 'src/pages/reportUsage/footer/InitialButtonState';

const OrdersListView = (props) => {
    const [first, setFirst] = useState(0);
    const [sortParam, setSortParam] = useState('surgeryStartDate');
    const [sortOrder, setSortOrder] = useState(1);
    const [formattedOrders, setFormattedOrders] = useState([]);
    const [deleteNotAllowedPopupOpen, setDeleteNotAllowedPopupOpen] =
        useState(false);
    const [sortedOrder, setSortedOrder] = useState({
        mCaseRefSort: false,
        physicianDisplaySort: false,
        accountSort: false,
        statusSort: false,
    });
    const [dialogZindex, setDialogZindex] = useState(10000);
    const [showTorqueQR, setShowTorqueQR] = useState(false);
    const [torqueQRParams, setTorqueQRParams] = useState(null);
    const dispatch = useDispatch();
    const PAGE_LIMIT = 50;
    const history = useHistory();
    const [showViewTemplate, handleViewTemplate] = useState(false);
    const [tableRowData, setTableRowData] = useState(null);
    const saveViewTemplate = () => {
        handleViewTemplate(!showViewTemplate);
    };
    const orders = useSelector(
        (state) => state.ordersReducer.listData.orderData,
        shallowEqual
    );
    const {
        patientIdVisibility,
        patientInformationVisibility,
        deliveryCheckEdit,
        deliveryCheckNoUsageToReport,
    } = useSelector((state) => state.loginReducer);

    const listDataLoading = useSelector(
        (state) => state.ordersReducer.listDataLoading
    );

    const totalRecords = useSelector(
        (state) => state.ordersReducer.listData.totalNumberOfResults
    );

    const userFilters = useSelector(
        (state) => state.filterReducer.userFilters,
        shallowEqual
    );

    const appliedfiltersUpdated = useSelector(
        (state) => state.setfilterOptionsReducer.appliedfiltersUpdated
    );

    const selectedDate = useSelector(
        (state) => state.filterReducer.selectedDate
    );
    const { t } = useTranslation();
    const contextValue = useContext(ReportUsageContext);
    const setFooterButtonStatuses =
        contextValue?.setFooterButtonStatuses || (() => {});

    const listViewStartDate = useSelector(
        (state) => state.filterReducer.listViewStartDate
    );

    const listViewEndDate = useSelector(
        (state) => state.filterReducer.listViewEndDate
    );

    const actionItemsOnly = useSelector(
        (state) => state.filterReducer.actionItemsOnly,
        shallowEqual
    );

    const pageNum = useSelector((state) => state.filterReducer.pageNum);

    const showFiltersResultsPanel = useSelector(
        (state) => state.filterReducer.showFilterResultsPanel
    );

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );
    const loggedInUserDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );

    const { qrCodeData, qrCodeLoading, qrCodeError, qrGenerated } = useSelector(
        (state) => state.qrCodeReducer
    );
    const ctaDetails = useSelector((state) => state.ctaDataReducer);

    const initialOrderLockState = {
        show: false,
        myCaseRef: null,
        modifiedBy: null,
        action: null,
    };
    const [usageProcessingPopup, setUsageProcessingPopup] = useState(null);
    const [showOrderLockedPopup, setShowOrderLockedPopup] = useState(
        initialOrderLockState
    );
    const closeOrderActionPopup = async () => {
        if (usageProcessingPopup) {
            const response = await unlockOrderFunc({
                action: usageProcessingPopup.action,
                myCaseRefId: usageProcessingPopup.myCaseRef,
            });
            if (response === 'error') return false;
        }
        setUsageProcessingPopup(null);
        setShowOrderLockedPopup(initialOrderLockState);
        return true;
    };
    const employeeRole = getUserDetails();

    useEffectWithErrorLogging(() => {
        dispatch(setCalendarView('List'));

        return () => {
            const newEndDate =
                new Date(selectedDate).setHours(0, 0, 0, 0) >=
                new Date().setHours(0, 0, 0, 0)
                    ? getEndOfTimeDate()
                    : getEndDateForStartDate(new Date(selectedDate), 0);
            dispatch(
                setFilters({
                    startDate: convertDateToISOString(
                        new Date(selectedDate),
                        'start'
                    ),
                    endDate: convertDateToISOString(newEndDate, 'end'),
                    pageLimit: '',
                    pageNum: 0,
                    sortOrder: 'ASC',
                    sortParam: 'surgeryStartDate',
                    filterByOrderStatus: [],
                })
            );

            // TODO : Remove this default value when issue of selecting page number programatically in Datatable is resolved
            dispatch(setListViewPageNum(0));
        };
    }, []);

    useEffectWithErrorLogging(() => {
        setFormattedOrders(
            (orders || []).map((order) => {
                return {
                    ...order,
                    accountNumber: parseInt(order.accountNumber, 10),
                    surgeryStartDate: new Date(order.surgeryStartDate),
                };
            })
        );
    }, [orders]);

    useNonInitialRenderHook(() => {
        dispatch(
            setFilters({
                pageNum: pageNum,
                pageLimit: PAGE_LIMIT,
            })
        );
        dispatch(
            getListData({
                ...userFilters,
                pageNum: pageNum,
                pageLimit: PAGE_LIMIT,
            })
        );
    }, [pageNum]);

    useEffectWithErrorLogging(() => {
        dispatch(setListViewPageNum(0));
        setFirst(0);
        dispatch(
            setFilters({
                startDate: convertDateToISOString(
                    new Date(props.OrderListStartDate),
                    'start'
                ),
                endDate: convertDateToISOString(listViewEndDate, 'end'),
                pageNum: 0,
                pageLimit: PAGE_LIMIT,
                sortParam: sortParam,
                sortOrder: sortOrder === 1 ? 'ASC' : 'DESC',
                filterByOrderStatus: actionItemsOnly
                    ? [20010, 20018, 10013, 20020, 12349]
                    : [],
            })
        );

        dispatch(
            getListData({
                ...userFilters,
                startDate: convertDateToISOString(
                    new Date(props.OrderListStartDate),
                    'start'
                ),
                endDate: convertDateToISOString(listViewEndDate, 'end'),
                pageNum: pageNum,
                pageLimit: PAGE_LIMIT,
                sortParam: sortParam,
                sortOrder: sortOrder === 1 ? 'ASC' : 'DESC',
                filterByOrderStatus: actionItemsOnly
                    ? [20010, 20018, 10013, 20020, 12349]
                    : [],
            })
        );
    }, [actionItemsOnly]);

    useNonInitialRenderHook(() => {
        if (sortParam) {
            dispatch(
                setFilters({
                    startDate: convertDateToISOString(
                        new Date(props.OrderListStartDate),
                        'start'
                    ),
                    sortParam: sortParam,
                    sortOrder: sortOrder === 1 ? 'ASC' : 'DESC',
                })
            );
            dispatch(
                getListData({
                    ...userFilters,
                    startDate: convertDateToISOString(
                        new Date(props.OrderListStartDate),
                        'start'
                    ),
                    sortParam: sortParam,
                    sortOrder: sortOrder === 1 ? 'ASC' : 'DESC',
                })
            );
        }
    }, [sortParam, sortOrder]);

    useNonInitialRenderHook(() => {
        if (appliedfiltersUpdated) {
            dispatch(setActionItemsOnly(false));
            dispatch(
                setFilters({
                    filterByOrderStatus: [],
                    pageNum: 0,
                    pageLimit: PAGE_LIMIT,
                })
            );

            getListData({
                ...userFilters,
                startDate: convertDateToISOString(
                    new Date(props.OrderListStartDate),
                    'start'
                ),
                filterByOrderStatus: [],
                pageNum: 0,
                pageLimit: PAGE_LIMIT,
            });
        }
    }, [appliedfiltersUpdated]);

    useNonInitialRenderHook(() => {
        dispatch(setListViewPageNum(0));
        setFirst(0);
        dispatch(
            setFilters({
                pageNum: 0,
                pageLimit: PAGE_LIMIT,
                filterByOrderStatus: actionItemsOnly
                    ? [20010, 20018, 10013, 20020, 12349]
                    : [],
            })
        );
        dispatch(
            getListData({
                ...userFilters,
                startDate: convertDateToISOString(
                    new Date(props.OrderListStartDate),
                    'start'
                ),
                pageNum: 0,
                pageLimit: PAGE_LIMIT,
                filterByOrderStatus: actionItemsOnly
                    ? [20010, 20018, 10013, 20020, 12349]
                    : [],
            })
        );
    }, [actionItemsOnly]);

    let colData = [
        {
            field: 'surgeryStartDate',
            header: t('common.surgeryDateLabel'),
            sortable: true,
            width: '10%',
        },
        {
            field: 'physicianDisplaylName',
            width: '12%',
            sortable: true,
        },

        {
            field: 'myCaseRef',
            width: '12%',
            sortable: true,
        },
        {
            field: 'accountName',
            width: '20%',
            sortable: true,
        },
        {
            field: 'orderStatusDescription',
            header: t('orders.orderListView.statusLabel'),
            sortable: true,
            width: '11%',
        },
        {
            field: 'callToActionList',
            header: 'Action',
            sortable: false,
            width: '12%',
        },
    ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        };
        switch (column.field) {
            case 'callToActionList': {
                const colors = {
                    [t('orders.orderStatuses.usagePending')]: '#F9D78C',
                    [t('orders.orderStatuses.usageCompleted')]: '#F9D78C',
                    [t('orders.orderStatuses.draftNotSubmitted')]: '#A8A8A8',
                    [t('orders.orderStatuses.shippedComplete')]: '#14853D',
                    [t('orders.orderStatuses.billingIssues')]: '#EB475B',
                    [t('orders.index.awaitingPO')]: '#EB475B',
                    [t('orders.orderStatuses.fullyInvoiced')]: '#14853D',
                    [t('orders.orderStatuses.inProcess')]: '#0DDCB9',
                    [t('orders.orderStatuses.usageSubmittedPendingInvoice')]:
                        '#0DDCB9',
                    [t('orders.orderStatuses.submittedPendingPriceOverride')]:
                        '#E26D38',
                    [t('orders.orderStatuses.partialShipped')]: '#7ECA2A',
                };
                extraProps.header = (
                    <HeaderLeftBordered padding={'2px 8px'}>
                        <DemiText>
                            {t('calendar.orders.orderListView.actionLabel')}
                        </DemiText>
                    </HeaderLeftBordered>
                );
                extraProps.body = (rowData) => {
                    const primaryCTAId = getDefaultCTAId(rowData);
                    const primaryCTA = rowData.callToActionList?.find(
                        (item) => item.ctaId === primaryCTAId
                    );
                    return (
                        <BodyContainer
                         id="home-orderslistview-cta-action-body-container"
                            color={colors[rowData.orderStatusDescription]}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {primaryCTA ? (
                            <FlexColumnContainer>
                                <SplitButtonContainer
                                id="home-orderslistview-cta-split-button-container"
                                    label={primaryCTA.ctaName}
                                    value={primaryCTA.ctaId}
                                    onClick={() => {
                                        try {
                                        handleCTAAction(primaryCTA, rowData);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                         }
                                    }}
                                    model={rowData.callToActionList
                                        ?.filter(
                                            (item) =>
                                                item.ctaId !== primaryCTAId
                                        )
                                        .map((action) => {
                                            return {
                                                label: action.ctaName,
                                                value: action.ctaId,
                                                command: () => {
                                                    handleCTAAction(
                                                        action,
                                                        rowData
                                                    );
                                                },
                                            };
                                        })}
                                    dropdownIcon="pi pi-chevron-down"                                   
                                ></SplitButtonContainer>
                                {rowData.torqueRecorded ? <Title color={PARKED_LABEL}>{t('orders.recordTorque.torqueRecorded')}</Title> : (qrGenerated[rowData.myCaseRef] || rowData?.qrGenerated) && <Title>{t('orders.recordTorque.qrGenerated')}</Title>}
                            </FlexColumnContainer>
                            ) : (
                                t('calendar.orders.orderListView.noActionMsg')
                            )}
                        </BodyContainer>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }
            case 'surgeryStartDate':
                extraProps.header = (
                    <HeaderDiv padding={'2px 0px 0px 10px'}>
                    <DemiText>
                        {t('common.surgeryDateLabel')}
                    </DemiText>
                    </HeaderDiv>
                );
                extraProps.bodyStyle = { padding: '0rem 1rem 0rem 0' };
                extraProps.body = (rowData) => {
                    // TODO: Populate this with all status...
                    return (
                        <OrderListDataContainer
                            height="85%"
                            justifyContent="flex-start"
                            flexDirection="column"
                            padding='0 14px'
                        >
                            <SurgeryDateText removePaddingLeft={true} mdFontSize={'12px'}>
                                {getDisplayDate(rowData.surgeryStartDate)}
                            </SurgeryDateText>
                            <RegularText
                                color="#C529BB"
                                fontSize="11px"
                                // margin="0 0 0 5px"
                            >
                                {fromOrderTypeToLabel(
                                    rowData.orderType,
                                    rowData.isMastOrder
                                )}
                            </RegularText>
                            <div style={{ height: '13px' }}></div>
                            <div style={{ height: '18px' }}></div>
                        </OrderListDataContainer>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'physicianDisplaylName': {
                const physicianEvent = {
                    sortField: 'physicianDisplaylName',
                    sortOrder: sortedOrder.physicianDisplaySort ? 1 : -1,
                };
                extraProps.header = (
                    <HeaderData id="home-orderslistview-physician-header" style={{padding: '0px'}} onClick={() => onSort(physicianEvent)}>
                        <DemiText>{t('common.physicianLabel')}</DemiText>
                        <SmallHeaderText>
                            {t('common.procedureLabel')}
                        </SmallHeaderText>
                    </HeaderData>
                );
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <OrderListDataContainer
                                height="85%"
                                justifyContent="flex-start"
                                flexDirection="column"
                            >
                                <BoldTruncatedItem
                                    className="home-orders-list-physician-dt-mask"
                                    mdFontSize={'12px'}
                                    lineHeight={'16px'}
                                >
                                    {rowData.physicianDisplaylName}
                                </BoldTruncatedItem>
                                <ProcedureTruncateText
                                    mdFontSize={'12px'}
                                    text={
                                        rowData.patientName
                                            ? rowData.patientName
                                            : ''
                                    }
                                >
                                    {rowData.primaryProcedureName}
                                </ProcedureTruncateText>
                                <div style={{ height: '18px' }}></div>
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }
            case 'myCaseRef': {
                const myCaseRefEvent = {
                    sortField: 'myCaseRef',
                    sortOrder: sortedOrder.mCaseRefSort ? 1 : -1,
                };
                extraProps.header = (
                    <HeaderData id="home-orderslistview-mycase-header" style={{padding: '0px'}} onClick={() => onSort(myCaseRefEvent)}>
                        <DemiText>
                            {t('calendar.orders.orderListView.myCaseRefLabel')}
                        </DemiText>
                        {(
                            <SmallHeaderText>
                                {t(
                                    'calendar.orders.orderListView.patientLabel'
                                )}
                            </SmallHeaderText>
                        )}
                    </HeaderData>
                );

                extraProps.body = (rowData) => {
                    return (
                        <>
                            <OrderListDataContainer
                                justifyContent="flex-start"
                                flexDirection="column"
                                height="85%"
                            >
                                <CaseRefText
                                    lineHeight={'16px'}
                                    style={{ cursor: 'pointer' }}
                                    mdFontSize={'12px'}
                                >
                                    {rowData?.myCaseRef}
                                </CaseRefText>
                                {
                                rowData.patientName ? (
                                    <RegularTruncateText className="home-orders-list-patient-name-dt-mask" mdFontSize={'12px'}>
                                        {rowData.patientName}
                                    </RegularTruncateText>
                                ) : (
                                    <RegularTruncateText height="13px"></RegularTruncateText>
                                )}
                                {rowData?.noOfSets ? (
                                    <SetContainer
                                        isSetVisible={rowData.noOfSets}
                                        width={'max-content'}
                                    >
                                        {rowData.noOfSets}{' '}
                                        {`${
                                            rowData.noOfSets > 1
                                                ? t('common.setsLabel')
                                                : t('common.setLabel')
                                        }`}
                                    </SetContainer>
                                ) : (
                                    <RegularTruncateText height="13px"></RegularTruncateText>
                                )}
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }
            case 'accountName': {
                const accountEvent = {
                    sortField: 'accountName',
                    sortOrder: sortedOrder.accountSort ? 1 : -1,
                };
                extraProps.header = (
                    <HeaderData id="home-orderslistview-account-header" style={{padding: '0px'}} onClick={() => onSort(accountEvent)}>
                        <DemiText>{t('common.accountLabel')}</DemiText>
                        {(
                            <SmallHeaderText>
                                {t('common.hrefLabel')}
                            </SmallHeaderText>
                        )}
                    </HeaderData>
                );
                extraProps.body = (rowData) => {
                    return (
                        <>
                            {/* <AccountNameNumberText style={{ width: '89%' }}>
                                <RegularTruncateText
                                    style={{
                                        minWidth: '0',
                                        maxWidth: '100%',
                                        padding: '0 4px 0 0',
                                    }}
                                >
                                    {rowData.accountName}
                                </RegularTruncateText>
                                {rowData.accountNumber}
                            </AccountNameNumberText> */}
                            <OrderListDataContainer
                                height="85%"
                                justifyContent="flex-start"
                                flexDirection="column"
                            >
                                <AccountNameNumberText
                                    className="home-orders-list-account-dt-mask"
                                    mdMargin={'0 0 6px 0'}
                                    mdFlexDirection={'column'}
                                    flexDirection={'row'}
                                    style={{ width: '95%' }}
                                >
                                    <LabelFont
                                        textOverflow={'ellipsis'}
                                        mdDisplay={'-webkit-box'}
                                        mdOrient={'vertical'}
                                        overflow={'hidden'}
                                        // width={'70%'}
                                        lineHeight={'16px'}
                                        fontFamily={'AvenirNextWorld Regular'}
                                        fontSize={'13px'}
                                        mdFontSize={'12px'}
                                        color={'#070707'}
                                        mdLineClamp={2}
                                        mdWidth={'100%'}
                                        padding={'0px 4px 0px 0px'}
                                        mdWhiteSpace={'normal'}
                                        whiteSpace={'nowrap'}
                                    >
                                        {rowData.accountName}
                                    </LabelFont>

                                    <LabelFont
                                        mdWidth={'100%'}
                                        lineHeight={'16px'}
                                        fontFamily={'AvenirNextWorld Regular'}
                                        fontSize={'13px'}
                                        mdFontSize={'12px'}
                                        mdFontStyle={'italic'}
                                        color={'#070707'}
                                        // width={'15%'}
                                    >
                                        {parseInt(rowData.accountNumber)}
                                    </LabelFont>
                                </AccountNameNumberText>
                                {
                                rowData.HRefId ? (
                                    <UNiDContainer className="home-orders-list-href-id-dt-mask">
                                        <RegularTruncateText
                                            color="#140F4B"
                                            fontSize="13px"
                                            mdFontSize={'12px'}
                                        >
                                            {rowData.HRefId}
                                        </RegularTruncateText>
                                    </UNiDContainer>
                                ) : (
                                    <RegularTruncateText height="13px"></RegularTruncateText>
                                )}
                                {rowData.unidCaseNo ? (
                                    <div id="home-orderslistview-unid-item-container" onClick={(e) => e.stopPropagation()}>
                                        <UnidItem
                                            uniDIdUrl={rowData.unidIdURL}
                                            uniDId={rowData.unidCaseNo}
                                            planStatus={rowData.unidPlanStatus}
                                            showPlan={rowData.isMtoStatus}
                                        />
                                    </div>
                                ) : (
                                    <UNiDContainer height="13px"></UNiDContainer>
                                )}
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }
            case 'orderStatusDescription': {
                const statusEvent = {
                    sortField: 'orderStatusDescription',
                    sortOrder: sortedOrder.statusSort ? 1 : -1,
                };
                extraProps.header = (
                    <DemiText id="home-orderslistview-status-header" onClick={() => onSort(statusEvent)}>
                        {t('calendar.orders.orderListView.statusLabel')}
                    </DemiText>
                );
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <OrderListDataContainer
                                height="85%"
                                justifyContent="flex-start"
                                flexDirection="column"
                            >
                                <StatusText lineHeight={'16px'}>
                                    {rowData.orderStatusDescription}
                                </StatusText>
                                <StatusFilterDiv
                                    text={
                                        rowData.HRefId
                                            ? rowData.HRefId
                                            : ''
                                    }
                                ></StatusFilterDiv>
                                <StatusFilterText
                                    text={rowData.unidCaseNo}
                                ></StatusFilterText>
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }

            case 'primaryProcedureName': {
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <OrderListDataContainer
                                height="85%"
                                justifyContent="flex-start"
                                flexDirection="column"
                            >
                                <RegularTruncateText mdFontSize={'12px'}>
                                    {rowData.primaryProcedureName}
                                </RegularTruncateText>
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }

            // case 'surgeryStartDate':
            //     extraProps.header = (
            //         <DemiText>{t('common.surgeryDateLabel')}</DemiText>
            //     );
            //     return {
            //         ...column,
            //         ...extraProps,
            //     };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    const onPageChange = (event) => {
        setFirst(event.first);
        dispatch(setListViewPageNum(event.page));
    };

    const onSort = (event) => {
        setSortParam(event.sortField);
        setSortOrder(event.sortOrder);
        setSortedOrder({
            ...sortedOrder,
            accountSort:
                event.sortField === 'accountName'
                    ? !sortedOrder.accountSort
                    : false,
            mCaseRefSort:
                event.sortField === 'myCaseRef'
                    ? !sortedOrder.mCaseRefSort
                    : false,
            physicianDisplaySort:
                event.sortField === 'physicianDisplaylName'
                    ? !sortedOrder.physicianDisplaySort
                    : false,
            statusSort:
                event.sortField === 'orderStatusDescription'
                    ? !sortedOrder.statusSort
                    : false,
        });
    };

    const [innerHeight, setInnerHeight] = useState(window.innerHeight);
    window.onresize = () => {
        setInnerHeight(window.innerHeight);
    };
    // for modify surgery
    const editSurgery = (myCaseRef) => {
        dispatch(setPediatricCheck(''));
        dispatch(resetNotes());
        dispatch(resetCreateOrUpdateSurgery());
        dispatch(resetProgressBarStatusSurgery());
        dispatch(resetSurgeryDetails());
        dispatch(resetSurgeryDetailsReducer());
        dispatch(resetShipToAddress());
        dispatch(resetBomData());
        history.push(getRoutePathWithParams(`/modifySurgery/${myCaseRef}`));
    };

    const getWCMSRedirectionLink = (order, cta) => {
        return getCTAWCMSLink(order, cta);
    };

    //Transfer Surgery
    const transferSurgery = (myCaseRef) => {
        history.push(getRoutePathWithParams(`/transferSurgery/${myCaseRef}`));
    };

    const orderLockedViewBtnClickHandler = async () => {
        if (!(await closeOrderActionPopup())) return;
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef:
                    usageProcessingPopup?.myCaseRef ||
                    showOrderLockedPopup?.myCaseRef,
                orderSummaryModal: true,
            })
        );
    };
    const [myCase, setMyCase] = useState();
    const handleCTAAction = async (cta, rowData) => {
        const isCopyCTA = isCopyCtaId(cta?.ctaId) && isTrueCopyCtaId(cta?.ctaId);
        if (isCopyCTA) {
            const isEquityOrder = rowData?.orderType === 'ZOR';
            const isConsignmentAddOrder = rowData?.orderType === 'KB';
            const fromPath = history?.location?.pathname
                ? history.location.pathname
                : null;
            if (isEquityOrder) {
                dispatch(resetEquityDetails());
                dispatch(
                    setActiveNavLink({
                        calendar: false,
                        orders: true,
                        inventory: false,
                        more: false,
                    })
                );
                history.push({
                    ...getRoutePathWithParams(
                        `/modifyEquity/${rowData?.myCaseRef}`
                    ),
                    state: {
                        from: fromPath,
                        account: rowData?.accountName,
                        sourceMyCaseRef: rowData?.myCaseRef,
                        sourceOrderType: rowData?.orderType,
                        isFromOrderHistory: false,
                        isCopyFromSummary: true,
                    },
                });
                return;
            }
            if (isConsignmentAddOrder) {
                dispatch(resetConsignmentAddDetails());
                dispatch(
                    setActiveNavLink({
                        calendar: false,
                        orders: true,
                        inventory: false,
                        more: false,
                    })
                );
                history.push({
                    ...getRoutePathWithParams('/consignmentAdd'),
                    state: {
                        from: fromPath,
                        account: rowData?.accountName,
                        sourceMyCaseRef: rowData?.myCaseRef,
                        sourceOrderType: rowData?.orderType,
                        isFromOrderHistory: false,
                        isCopyFromSummary: true,
                    },
                });
                return;
            }
            dispatch(resetSurgeryDetails());
            dispatch(
                setActiveNavLink({
                    calendar: true,
                    orders: false,
                    inventory: false,
                    more: false,
                })
            );
            history.push({
                ...getRoutePathWithParams('/scheduleSurgery'),
                state: {
                    from: fromPath,
                    sourceMyCaseRef: rowData?.myCaseRef,
                    sourceOrderType: rowData?.orderType,
                    isMastOrder: rowData?.isMastOrder,
                    isFromOrderHistory: false,
                    isCopyFromSummary: true,
                    account: rowData?.accountName,
                },
            });
            return;
        }

         setMyCase(rowData?.myCaseRef);
        dispatch(setPediatricCheck(''));
        dispatch(resetNotes());
        setFooterButtonStatuses(initialButtonState());
        let orderLockedData, orderStatus;
        const orderLockAction = getOrderLockedAction(
            cta.ctaId,
            rowData.orderType,
            rowData.orderStatusDescription
        );
        dispatch({ type: RESET_CANCEL_USAGE_STATES });
        cta.ctaId === CTA_IDS.procedureData &&
            dispatch(
                getConfigurations(
                    { resourceType: 'visibility', module: EQUITY },
                    REPORT_PROCEDURE_DATA
                )
            );
        cta.ctaId === CTA_IDS.noUsageToReport &&
            dispatch(
                getConfigurations(
                    { resourceType: 'visibility', module: NO_USAGE_REPORT },
                    NO_USAGE_REPORT
                )
            );
        if (
            orderLockAction &&
            ((cta.ctaId === CTA_IDS.editOrder &&
                rowData.orderType === ORDER_TYPES.surgery &&
                process.env.ENABLE_SCHEDULE_SURGERY) ||
                ((cta.ctaId === CTA_IDS.reportUsage ||
                    (rowData.orderType === ORDER_TYPES.usage &&
                        (cta.ctaId === CTA_IDS.editOrder ||
                            cta.ctaId === CTA_IDS.reportPayment))) &&
                    process.env.ENABLE_REPORT_USAGE) ||
                (process.env.ENABLE_NO_USAGE_TO_REPORT &&
                    loggedInUserDetails &&
                    (cta.ctaId === CTA_IDS.noUsageToReport ||
                        cta.ctaId === CTA_IDS.unidPostponed)))
        ) {
            orderLockedData = await checkIfOrderLockedFunc({
                action: orderLockAction,
                myCaseRefId: rowData?.myCaseRef,
                orderType:
                    orderLockAction === 'ReportUsage'
                        ? ORDER_TYPES.usage
                        : rowData.orderType,
            });
            if (cta.ctaId === CTA_IDS.reportUsage) {
                orderStatus = await getOrderStatusDetailsFunc(
                    rowData?.myCaseRef
                );
            }
            if (
                process.env.ENABLE_NO_USAGE_TO_REPORT &&
                loggedInUserDetails &&
                cta.ctaId === CTA_IDS.noUsageToReport
            ) {
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: rowData?.myCaseRef,
                        orderSummaryModal: false,
                    })
                );
            }
        }

        if (
            cta.ctaId === CTA_IDS.editOrder &&
            rowData.orderType === ORDER_TYPES.surgery &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                if (
                    ctaDetails?.orderStatus ===
                    t('orders.orderQuickFilters.usageOrders.inProcess')
                ) {
                    setTableRowData(rowData);
                    editSurgery(rowData?.myCaseRef);
                } else {
                    editSurgery(rowData?.myCaseRef);
                }
            }
        } else if (
            cta.ctaId === CTA_IDS.transfer &&
            (rowData.orderType === ORDER_TYPES.surgery ||
                rowData.orderType === ORDER_TYPES.usage) &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            transferSurgery(rowData?.myCaseRef);
        } else if (
            cta.ctaId === CTA_IDS.delete &&
            (rowData.orderType === ORDER_TYPES.surgery ||
                rowData.orderType === ORDER_TYPES.usage)
        ) {
            rowData?.unidCaseId || rowData?.unidCaseNo
                ? setDeleteNotAllowedPopupOpen(true)
                : dispatch(
                      showDeleteOrderAction({
                          isDeletePopup: true,
                          deleteMyCaseRef: rowData?.myCaseRef,
                          isOrderDetailsModal: false,
                          isOtherUser:
                              loggedInUserDetails?.uid &&
                              loggedInUserDetails.uid !== rowData.createdBy
                                  ? true
                                  : false,
                      })
                  );
        } else if (
            cta.ctaId === CTA_IDS.viewOrder &&
            (rowData.orderType === ORDER_TYPES.surgery ||
                rowData.orderType === ORDER_TYPES.usage)
        ) {
            viewSurgeryDetailsClick(rowData);
        } else if (
            cta.ctaId === CTA_IDS.createTemplate &&
            (rowData.orderType === ORDER_TYPES.surgery ||
                rowData.orderType === ORDER_TYPES.usage)
        ) {
            saveViewTemplate();
            setTableRowData(rowData);
        } else if (
            (cta.ctaId === CTA_IDS.billingSummary ||
                cta.ctaId === CTA_IDS.viewAdjustments) &&
            (rowData.orderType === ORDER_TYPES.surgery ||
                rowData.orderType === ORDER_TYPES.usage)
        ) {
            dispatch(
                setOrderSummaryTabAction({
                    selectedTabId: OrderSummaryTabs()[4].id,
                }) //Setting Billing Summary Id to OrderSummary redux state selectedTabId.
            );
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: rowData?.myCaseRef,
                    // resourceType: 'BILLING_SUMMARY',
                    orderSummaryModal: !orderSummaryModal,
                })
            );
        } else if (
            (cta.ctaId === CTA_IDS.reportUsage ||
                (rowData.orderType === ORDER_TYPES.usage &&
                    (cta.ctaId === CTA_IDS.editOrder ||
                        cta.ctaId === CTA_IDS.reportPayment))) &&
            process.env.ENABLE_REPORT_USAGE
        ) {
            dispatch(setPediatricCheck(''));
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user
                        ? orderLockedData?.user
                        : orderStatus?.userId,
                    action: orderLockAction,
                });
            } else if (isUsageSubmissionProcessing(orderStatus)) {
                setUsageProcessingPopup({
                    myCaseRef: rowData?.myCaseRef,
                    userId: orderStatus.userId,
                    action: orderLockAction,
                });
            } else {
                dispatch(resetProgressBarStatus());
                dispatch(resetReportUsageStates());
                const reportUsageObj = {
                    resourceType: getReportUsageResourceType(
                        rowData.orderStatusDescription,
                        cta.ctaId
                    ),
                    myCaseRef: rowData?.myCaseRef,
                    fromOrdersList: false,
                    isFromOrderDetailsModal: false,
                };
                dispatch(storeSurgeryDetails(reportUsageObj));
                localStorage.setItem(
                    'myCaseRefUsage',
                    JSON.stringify(reportUsageObj)
                );
                history.push({
                    ...getRoutePathWithParams(
                        `/reportUsage/${rowData?.myCaseRef}`
                    ),
                    state: {
                        from: '/',
                        orderStatus: rowData.orderStatusDescription,
                    },
                });
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            cta.ctaId === CTA_IDS.noUsageToReport
        ) {
            if (deliveryCheckNoUsageToReport === VISIBLE) {
                const deliveryCheckPayload = {
                    orderType: ORDER_TYPES.surgery,
                    action: 'cancel',
                    myCaseRef: rowData.myCaseRef,
                };
                dispatch(getCheckOrderActionEligibility(deliveryCheckPayload));
            }

            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                const diffBetweenDates = getNumberOfDaysBetweenTwoDates(
                    new Date(),
                    rowData.surgeryStartDate
                );
                if (
                    diffBetweenDates <= 0 ||
                    rowData.createdBy !== loggedInUserDetails.uid
                ) {
                    dispatch(
                        setShowNoUsageToReportOrCancelPopup({
                            showNoUsagePopup:
                                rowData.createdBy === loggedInUserDetails.uid,
                            showCancelPopup:
                                rowData.createdBy !== loggedInUserDetails.uid,
                            surgeryData: rowData,
                            viewProcedureScreen: false,
                            showUnidPostponePopup: false,
                            showCaseCancelOrPostpone: false,
                            isFromOrderDetailsModal: false,
                        })
                    );
                } else if (
                    diffBetweenDates >= 0 &&
                    rowData.createdBy === loggedInUserDetails.uid
                ) {
                    if (deliveryCheckEdit === VISIBLE) {
                        setTableRowData(rowData);
                    } else {
                        dispatch(
                            cancelUsageOrderRequest(
                                { myCaseRef: rowData.myCaseRef },
                                true,
                                false
                            )
                        );
                    }
                }
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            cta.ctaId === CTA_IDS.caseCancelOrPostpone
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                dispatch(
                    getSurgeryDetails(rowData?.myCaseRef, true, false, true)
                );
                dispatch(
                    setShowNoUsageToReportOrCancelPopup({
                        showNoUsagePopup: false,
                        showCancelPopup: false,
                        surgeryData: rowData,
                        viewProcedureScreen: false,
                        showCaseCancelOrPostpone: true,
                        isFromOrderDetailsModal: false,
                    })
                );
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            cta.ctaId === CTA_IDS.unidPostponed
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData?.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                // const diffBetweenDates = getNumberOfDaysBetweenTwoDates(
                //     new Date(),
                //     rowData.surgeryStartDate
                // );
                // if (
                //     diffBetweenDates <= 0 ||
                //     rowData.createdBy !== loggedInUserDetails.uid
                // ) {
                dispatch(
                    getSurgeryDetails(rowData?.myCaseRef, true, false, true)
                );
                dispatch(
                    setShowNoUsageToReportOrCancelPopup({
                        showNoUsagePopup: false,
                        showCancelPopup: false,
                        surgeryData: rowData,
                        viewProcedureScreen: false,
                        showUnidPostponePopup: true,
                        showCaseCancelOrPostpone: false,
                        isFromOrderDetailsModal: false,
                    })
                );
                // } else if (
                //     diffBetweenDates > 0 &&
                //     rowData.createdBy === loggedInUserDetails.uid
                // ) {
                //     dispatch(
                //         cancelUsageOrderRequest(
                //             { myCaseRef: rowData.myCaseRef },
                //             true
                //         )
                //     );
                // }
            }
        } else if (
            cta.ctaId === CTA_IDS.viewUsageReports &&
            (rowData.orderType === ORDER_TYPES.surgery ||
                rowData.orderType === ORDER_TYPES.usage)
        ) {
            dispatch(resetDiscrepancyUsageDetails());
            dispatch(
                setOrderStatus({ orderStatus: rowData.orderStatusDescription })
            );
            dispatch(
                setSendReportModalState({
                    showModal: true,
                    myCaseRefId: rowData?.myCaseRef,
                    isUsageReportOrderListPage: true,
                })
            );
            if (
                rowData.orderStatusDescription ===
                    OrderStatuses().paymentInformationNeeded ||
                rowData.orderStatusDescription === OrderStatuses().billingIssues
            ) {
                dispatch(
                    fetchUsageDetailsRequest({
                        resourceType: 'reportPayment',
                        myCaseRef: rowData?.myCaseRef,
                        isDiscrepencyCheck: true,
                    })
                );
            }
        } else if (
            cta.ctaId === CTA_IDS.requestInvoice &&
            (rowData.orderType === ORDER_TYPES.surgery ||
                rowData.orderType === ORDER_TYPES.usage)
        ) {
            const requestInvoiceProp = {
                requestInvoiceState: true,
                myCaseRefId: rowData?.myCaseRef,
                isRequestInvoiceOrderListPage: true,
            };
            dispatch(showHideRequestInvoice(requestInvoiceProp));
        } else if (cta.ctaId === 'CTA_026') {
            setTorqueQRParams({ myCaseRef: rowData.myCaseRef });
            setShowTorqueQR(true);
        } else {
            window.location.href = getWCMSRedirectionLink(rowData, cta);
        }
    };
    const {
        orderSummaryModal,
        requestInvoiceState,
        isRequestInvoiceOrderListPage,
    } = useSelector((state) => state.orderSummaryReducer);

    const viewSurgeryDetailsClick = (data) => {
        dispatch(getConfigurations({resourceType: 'visibility', module: fromOrderTypeToModuleName(data.orderType, data.isMastOrder, data.isUsageMastOrder)}, ORDERS));
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: data?.myCaseRef,
                orderSummaryModal: true,
            })
        );
        dispatch(
            setOrderStatus({
                orderStatus: data.orderStatusDescription,
            })
        );
    };
    const closeCardPreviewHandler = () => {
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        props.openSearchModal();
        dispatch(setItemListView(false));
    };

    const [tableHeight, setTableHeight] = useState('');
    useEffectWithErrorLogging(() => {
        const bannerlessHeight = showFiltersResultsPanel
            ? innerHeight - 360
            : innerHeight - 320;
        const height = bannerHeight
            ? bannerlessHeight - bannerHeight?.split('px')[0] + 'px'
            : bannerlessHeight + 'px';
        setTableHeight(height);
    }, [innerHeight, bannerHeight, showFiltersResultsPanel]);

    const closeQrCodePopup = (requestParams) => {
        try {
            const myCaseRef = requestParams?.myCaseRef;
            setShowTorqueQR(false);
            if (myCaseRef && !qrGenerated[myCaseRef]) {
                dispatch(setQrGenerated({ [myCaseRef]: true }));
            }
        } catch (error) {
            logErrorToConsole(error);
        }
    };

    

    return (
        <OrdersListViewContainer>
            {listDataLoading ? (
                <Spinner id="home-ordersListView-ordersListView-listDataLoadingSpinner" animation="border" variant="primary" small />
            ) : (
                <Datatable
                    id={'home-ordersListView-datatable'}
                    backgroundColorOdd={'#FFFFFF99'}
                    backgroundColorEven={'#F5F5F5'}
                    resizableColumns
                    columns={colData}
                    data={formattedOrders}
                    totalRecords={totalRecords}
                    rows={PAGE_LIMIT}
                    scrollHeight={tableHeight}
                    paginator
                    first={first}
                    onPageChange={onPageChange}
                    onSort={onSort}
                    sortField={sortParam}
                    sortOrder={sortOrder}
                    scrollable
                    onRowClick={(event) => viewSurgeryDetailsClick(event.data)}
                    isListView
                    showScrollBar={true}
                    height={'100px'}
                    ipadNoMarginTop={true}
                    marginTop={'5px'}
                    paginationLeftMarginBottom={'3px'}
                    rightCOntentMarginTop={4}
                />
            )}
            {deleteNotAllowedPopupOpen && (
                <UnidHubOrderDeletePopup
                id="home-orderslistview-unidhuborderdeletepopup"
                    onClose={() => {
                        try {
                        setDeleteNotAllowedPopupOpen((prev) => !prev);
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {(usageProcessingPopup || showOrderLockedPopup.show) && (
                <CancelAlertPopup
                    fitContent={!!usageProcessingPopup}
                    popupTitle={t(
                        usageProcessingPopup
                            ? 'orders.shipTrackLabels.usageProcessingTitle'
                            : 'orders.shipTrackLabels.lockededit'
                    )}
                    alertMessage={
                        usageProcessingPopup
                            ? t('orders.shipTrackLabels.usageProcessingMessage', {
                                  orderNumber: usageProcessingPopup.myCaseRef,
                                  userId: usageProcessingPopup.userId,
                              })
                            : `${t('orders.shipTrackLabels.mycaseorder')} ${
                        showOrderLockedPopup?.myCaseRef
                    } ${t('orders.shipTrackLabels.msg')} ${
                        showOrderLockedPopup.modifiedBy
                    }.`}
                    btn1Label={t('common.cancelButton')}
                    cancelBtn
                    btn2Label={
                        (usageProcessingPopup || showOrderLockedPopup)?.action !==
                            'DraftUsageEdit' &&
                        t('accounts.accountFilterBox.view')
                    }
                    btnCloseClickHandler={closeOrderActionPopup}
                    btn1ClickHandler={closeOrderActionPopup}
                    btn2ClickHandler={orderLockedViewBtnClickHandler}
                />
            )}
            <OrderDetails
                showOrderListDetails={orderSummaryModal}
                orderListDetailsClose={closeCardPreviewHandler}
                fromCalendar={true}
                fromListScreen={true}
            />
            {showViewTemplate && tableRowData && (
                <>
                    <ModalDialog
                        marginTop={'16.2rem'}
                        overflowX={'hidden'}
                        maxWidth={'841px'}
                        handleClose={saveViewTemplate}
                        zIndex={dialogZindex}
                        paddingBottom={'190px'}
                        padding={'16px 3px 16px 16px'}
                        isMobileDevice={true}
                        afterSubmitTemplate={false}
                    >
                        <CreateTemplate
                        id="home-orderslistview-createtemplate"
                            handleClose={saveViewTemplate}
                            origin={'calendar'}
                            orderData={tableRowData?.myCaseRef}
                            onOpen={() => {
                                try {
                                setDialogZindex(2000);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            onClose={() => {
                                try {
                                setDialogZindex(10000);
                                } catch (error) {
                                    logErrorToConsole(error);
                                 }
                            }}
                            templateMandatoryFields={checkTemplateReviewUserRoleChanges(
                                employeeRole,
                                SURGERY_TEMPLATE_MANDATORY_FIELDS
                            )}
                        />
                    </ModalDialog>
                </>
            )}
            {requestInvoiceState && isRequestInvoiceOrderListPage && (
                <RequestInvoice
                    onCloseRequestInvoiceHandler={() => {
                       try {
                        dispatch(
                            showHideRequestInvoice({
                                requestInvoiceState: false,
                                myCaseRefId: '',
                                isRequestInvoiceOrderListPage: false,
                                isRequestInvoiceSearchListPage: false,
                            })
                        );
                        } catch (error) {
                            logErrorToConsole(error);
                         }
                    }}
                />
            )}
            {showTorqueQR && (
                <ModalDialog
                    handleClose={() => closeQrCodePopup(torqueQRParams)}
                    zIndex={2000}
                    paddingBottom={'16px'}
                    paddingTop={'16.2rem'}
                    overflowX={'hidden'}
                    modalHeight={'396px'}
                    padding={'1px'}
                    maxWidth={'450px'}
                    isMobileDevice={true}
                    crossMarginTop={'15px'}
                >
                    <TorqueQRCode
                        requestParams={torqueQRParams}
                        qrCodeData={qrCodeData}
                        qrCodeLoading={qrCodeLoading}
                        qrCodeError={qrCodeError}
                        setShowTorqueQR={setShowTorqueQR}
                        qrGenerated={qrGenerated}
                        onClose={() => closeQrCodePopup(torqueQRParams)}
                    />
                </ModalDialog>
            )}
        </OrdersListViewContainer>
    );
};

export default OrdersListView;
